let count = 0
let maxRetries = 25
const checkAndSelectOption = setInterval(() => {
  
    if(document.querySelector('.rc_widget__option--subsave label')){
        clearInterval(checkAndSelectOption); // Stop checking once it's found
        document.querySelector('.rc_widget__option--subsave label').click() 

        // Add a small delay to ensure DOM updates after click
        setTimeout(() => {
            const parentElem = document.querySelector('.rc-selling-plans')
            if(parentElem && !parentElem.querySelector('.features-container')){
                
                const featuresElem = document.createElement('div')
                featuresElem.className = "features-container"
                featuresElem.style.cssText = `
                `
                
                featuresElem.innerHTML = [
                    "Save 10% more", 
                    "Pause or Cancel Anytime", 
                    "Convenient Monthly Delivery"
                ]
                .map(feature => `
                    <div class="subscription-feature-item" style="
                        display: flex; 
                        align-items: center; 
                    ">
                        <img src="https://cdn.shopify.com/s/files/1/0487/2798/2229/files/check.svg" 
                             style="width: 16px; height: 16px; margin-right: 8px;" />
                        <div>${feature}</div>
                    </div>
                `)
                .join('') 

                parentElem.insertBefore(featuresElem, parentElem.firstChild);
                console.log("Features added successfully");

            } else if (!parentElem) {
                console.log("Parent element .rc-selling-plans not found");
            } else {
                console.log("Features already exist");
            }
        }, 100); // Small delay after click

    }

    count ++
    console.log("count", count)
    if(count > maxRetries){
        console.log("max retry reached")
        clearInterval(checkAndSelectOption);
    }
    
}, 500);